import { NgForOf } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ActivitySubscriptionType } from '@recruitee/http/types';
import { I18nService } from '@recruitee/i18n';
import { TableComponent } from '@recruitee/user-interface';

@Component({
  selector: 'rt-activity-subscriptions-table',
  templateUrl: './activity-subscriptions-table.component.html',
  styleUrls: ['./activity-subscriptions-table.component.less'],
  standalone: true,
  imports: [TableComponent, NgForOf],
})
export class ActivitySubscriptionsTableComponent {
  @Input() public types: ActivitySubscriptionType[];
  @Input() public title: string;

  public readonly typeTranslations = {
    [ActivitySubscriptionType.Web]: this.i18n.translate('app.subscriptions.types.web_v2'),
    [ActivitySubscriptionType.Mobile]: this.i18n.translate('app.subscriptions.types.mobile_v2'),
    [ActivitySubscriptionType.Email]: this.i18n.translate('app.subscriptions.types.email'),
    [ActivitySubscriptionType.Slack]: this.i18n.translate('app.subscriptions.types.slack'),
  };

  constructor(private i18n: I18nService) {}

  public trackByType(index: number, type: ActivitySubscriptionType): ActivitySubscriptionType {
    return type;
  }
}
